export class TerminalRegionActions {
  static REMOVE_TRANSPORTS = 0
  static DEFAULT = 1
  static SPLICE_TRANSPORTS = 2
  static AT_LEAST_ONE_TRANSPORT = 3

  static actionsNames = {
    [TerminalRegionActions.REMOVE_TRANSPORTS]: 'removeTransports',
    [TerminalRegionActions.SPLICE_TRANSPORTS]: 'spliceTransports',
    [TerminalRegionActions.AT_LEAST_ONE_TRANSPORT]: 'atLeastOneTransport'
  }

  static transportConditions = {
    [TerminalRegionActions.REMOVE_TRANSPORTS]: false,
    [TerminalRegionActions.DEFAULT]: true,
    [TerminalRegionActions.SPLICE_TRANSPORTS]: false,
    [TerminalRegionActions.AT_LEAST_ONE_TRANSPORT]: true
  }

  static conditionsForTransportPassKind = {
    [TerminalRegionActions.REMOVE_TRANSPORTS]: false,
    [TerminalRegionActions.DEFAULT]: true,
    [TerminalRegionActions.SPLICE_TRANSPORTS]: true,
    [TerminalRegionActions.AT_LEAST_ONE_TRANSPORT]: true
  }
}
